import apiClient from '@/shared/services/apiClient';

/**
 * Patient-facing blood-sample viability lookup. The dashboard reads
 * this to decide whether to show a countdown ("you have X hours to
 * add tests without a new draw") and whether enrollment routes through
 * a home kit or a lab add-on.
 *
 * Returns null when the patient has no sample on record at all.
 * Expired samples still come back with `is_viable=false` — the caller
 * decides whether to display the most recent draw regardless.
 */

export interface BloodSampleViability {
    id: number;
    user_id: number;
    organization_id: number | null;
    sample_type: 'whole_blood' | 'finger_prick' | 'dried_blood_spot' | 'other';
    collected_at: string;
    viability_hours: number;
    expires_at: string;
    is_viable: boolean;
    seconds_remaining: number;
    ohd_result_set_id: number | null;
}

export const BloodViabilityService = {
    async getMine(): Promise<BloodSampleViability | null> {
        return apiClient.get<BloodSampleViability | null>('/api/biomatch/blood-viability/me');
    },
};

export default BloodViabilityService;
